
import { CustomButton } from '@/components';
export default {
  name: 'SimpleCard',
  components: { CustomButton },
  props: {
    blok: Object,
  },
}
